import { Chip, Divider, Stack, Typography } from "@mui/material";
import React from "react";

import {
  HubHookFormDatePicker,
  HubPrioritySelect,
  HubProgressBar,
  WorkOrderRoutingSelect,
} from "../../components";
import { JOB_STATUSES } from "../../constants";
import QuickWorkOrderForm from "./QuickWorkOrderForm";

export const StatusChip = ({ status }) => {
  const chipProps = { variant: "colorTag", sx: { fontSize: 10 } };

  let props = { label: "Not Started", flow: "grey", ...chipProps };
  switch (status) {
    case JOB_STATUSES.IN_PROGRESS:
      props = { label: "In Progress", flow: "green", ...chipProps };
      break;
    case JOB_STATUSES.COMPLETE:
      props = { label: "Completed", flow: "blue", ...chipProps };
    default:
      break;
  }
  return <Chip {...props} />;
};

const QuickWorkOrderDetailsContent = ({
  workOrder,
  part,
  status,
  percent = 0,
}) => {
  return (
    <Stack gap="25px">
      <Stack gap="5px">
        <Stack direction="row" gap="5px" alignItems="center">
          <Typography variant="boldCaption">{workOrder}</Typography>
          <StatusChip status={status} />
        </Stack>
        <Typography variant="body2">
          Quick Work Order details, view completed routings, adjust current work
          order location, etc.
        </Typography>
        <HubProgressBar percent={percent} />
      </Stack>
      <Divider orientation="horizontal" flexItem />

      <QuickWorkOrderForm workOrder={workOrder} part={part} percent={percent} />
    </Stack>
  );
};

export default QuickWorkOrderDetailsContent;
